import { createCheckoutAPIClient } from '@/scopes/checkout/infrastructure/api/checkoutAPIClient'

export const checkoutAPIClient = createCheckoutAPIClient({})
